module.exports = __webpack_public_path__ + "img/non-melanoma-skin-leaflet.16a210c5.jpg";